module.exports = __webpack_public_path__ + "static/media/drivewayProject4.c676ee10.jpg";